var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.application)?_c('v-container',[_c('QApplicationPdfPreview',{key:_vm.applicationKey,attrs:{"application":_vm.application,"secure":_vm.secure}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }